<template>
<div id="login" class="loginbg">
    <v-content>
        <v-layout> 
            <v-flex xs12>
                <a href="https://loadmax.com" > <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg"></a>
            </v-flex>
        </v-layout> 
        <v-container fluid fill-height class="">
            <v-layout align-center justify-center> 
                <v-flex xs12 sm8 md3 lg3>
                    <v-card class="elevation-1 pa-3">
                        <v-card-text>
                            <div class="layout column ">
                                <h1 class="flex">Change Email</h1>
                            </div>
                            <v-form v-if="showForm" @submit.prevent="changeUserEmail()">
                                <v-text-field v-validate="{required: 'login', email: true}" :error-messages="errors.collect('email')"  name="email" label="Enter new Email" type="text" v-model="form.email"></v-text-field>
                                <v-btn block type="submit" color="orange darken-1 white--text">Submit</v-btn>
                            </v-form>
                            <v-alert 
                                v-if="responseMsg != '' && responseColor == 'red' && !showForm"
                                :value="true"
                                type="error"
                            >
                                {{responseMsg}}
                            </v-alert>
                        </v-card-text>
                    </v-card>
                    <v-flex align-end class="text-md-center my-4">
                        <span class="calltxt">Questions? Call 1-866-925-6608</span>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>
<script>
import { mapGetters,mapActions} from "vuex";
import services from "../services/HttpService";
import config from "../config";
export default {
    data: () => ({
        form: {
            email: "",
        },
        showForm:'',
        responseMsg:'',
        responseColor:''
    }),
    created() {
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        services.post("users/verify-token", {
            "token": self.$route.query.token
        })
        .then(res => {
            wApp.$emit("showLoader", {
                show: false
            });
            if (res.data.status) {
                self.showForm = true;
            } else {
                self.responseMsg = res.data.message;
                self.responseColor = config.errMsgColorStr;
            }
        })
        .catch(err => {
            wApp.$emit("showLoader", {
                show: false
            });
            self.responseMsg = res.data.message;
            self.responseColor = config.errMsgColorStr;
        });
    },
    methods: {
        ...mapActions([]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        changeUserEmail(e) {
            const self = this,
                wApp = window.getApp;
            self.$validator.validateAll().then(isValid => {
                if (isValid) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    services.post("users/change-email", {
                            "email": self.form.email,
                            "token": self.$route.query.token
                        })
                        .then(res => {
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            if (res.data.status) {
                                self._showToast(res.data.message);
                            } else {
                                self._showToast(res.data.message, config.errMsgColorStr);
                            }
                            self.form.email = '';
                            self.$validator.reset();
                        })
                        .catch(err => {
                            self.form.email = '';
                            self.$validator.reset();
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            self._showToast(err.message,config.errMsgColorStr);
                        });
                }
            })
            .catch(e => {
                wApp.$emit("showLoader", {
                    show: false
                });
                return false;
            });
        }
    }
};
</script>

<style lang="css" scoped>
#login {
    height:100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
.text-md-center{
    text-align:center !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangeEmail.vue